import React, { useState, useEffect } from 'react';
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import ActionButton from 'jbc-front/components/ActionButton';
import _ from 'lodash';
import { RadioFieldWithIssuedDate } from 'src/jbc-front/components/Form';
import styles from './SelectIssuedDateModal.scss';
import PreviewPdfModalContainer from 'src/containers/PreviewPdfModalContainer';
import { useTranslation } from 'react-i18next';
import { isDateStringFormat } from 'src/utils/CustomValidators';
import { formatDateParam } from 'src/utils/Date';

const SelectIssuedDateModal = (props) => {
  const { t } = useTranslation();
  const { isOpen, hideModal, url } = props;

  const header = `PDF ${t(
    'features.YearEndReportWithholdingReports.components.WithholdingReportTableRow.withholding_report'
  )}`;

  const [isShowPreview, setIsShowPreview] = useState(false);

  const [issuedDate, setIssuedDate] = useState(null);
  const [issuedDateParams, setIssuedDateParams] = useState('');
  const downloadUrl = `${url}${issuedDateParams}`;

  const handleChangeIssuedDate = (date) => {
    setIssuedDate(date);
    // if no date selected, set issuedDateParams to empty string
    if (!date) {
      setIssuedDateParams('');
      return;
    }
    // if no error (date is valid), set issuedDateParams
    if (!isDateStringFormat(date)) {
      const issued_date = formatDateParam(date);
      setIssuedDateParams(`&issued_date=${issued_date}`);
    }
  };

  return (
    <CommonModal isOpen={isOpen} hideModal={hideModal} ariaHideApp={false}>
      <CommonModal.Header hideModal={hideModal}>
        <div className={styles.modalHeader}>
          <span>{header}</span>
        </div>
      </CommonModal.Header>
      <CommonModal.Body style={{ overflow: 'visible' }}>
        <RadioFieldWithIssuedDate
          name="issuedDate"
          input={{ value: issuedDate, onChange: handleChangeIssuedDate }}
          required
        />
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={hideModal} className="u-mr20">
          {t('features.YearEndReportWithholdingReports.components.PdfCreateModal.cancel')}
        </Button>
        <ActionButton
          primary
          className={styles.overrideActionButton}
          onClick={() => setIsShowPreview(true)}
          disabled={isDateStringFormat(issuedDate) ? true : false}
        >
          {t('features.YearEndReportWithholdingReports.components.PdfCreateModal.create')}
        </ActionButton>

        <PreviewPdfModalContainer
          header={t('features.YearEndReportWithholdingReports.components.WithholdingReportTableRow.withholding_report')}
          isOpen={isShowPreview}
          hideModal={() => setIsShowPreview(false)}
          url={downloadUrl}
        />
      </CommonModal.Footer>
    </CommonModal>
  );
};

export default SelectIssuedDateModal;
